import { QueryHookOptions, useQuery } from "@apollo/client";

// Apollo
import queryGQL from "../query/stripeAccountDetails.graphql";
import {
  StripeAccountDetailsQuery,
  StripeAccountDetailsQueryVariables,
} from "@whoppah/apollo/schema";

export const useStripeAccountDetails = (
  options?: QueryHookOptions<
    StripeAccountDetailsQuery,
    StripeAccountDetailsQueryVariables
  >
) => {
  return useQuery(queryGQL, options);
};
